var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCheckCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 55 55",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 0C12.337 0 0 12.337 0 27.5S12.337 55 27.5 55 55 42.663 55 27.5 42.663 0 27.5 0zm15.37 20.263L25.295 37.7c-1.034 1.034-2.689 1.103-3.791.07l-9.305-8.478c-1.102-1.034-1.171-2.757-.207-3.86a2.727 2.727 0 013.86-.137l7.375 6.754L38.94 16.335a2.746 2.746 0 013.929 0 2.746 2.746 0 010 3.928z"
  })));
}

export default __webpack_public_path__ + "be985340d4f223c627b5d5ffdcd5604e.svg";
export { SvgCheckCircle as ReactComponent };